import amplitude from 'amplitude-js';

export const initAmplitude = (userId?: string) => {
  const instance = amplitude.getInstance();
  instance.init(process.env.AMPLITUDE_API_KEY || '');

  if (userId) {
    instance.setUserId(userId);
  }
};

const useTracking = () => amplitude.getInstance();

export default useTracking;
